import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

const propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    style: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

/**
 * Simple stateless component to render an icon for TextField, privatly used by
 * TextField.
 *
 * @param {ReactElement} [props.icon] - The icon to be rendered
 * @param {string} [props.className] - Optional wrapper classname
 * @param {Object} [props.style] - Optional wrapper style
 * @param {Function} [props.onClick] - Optional click callback
 * @returns {ReactElement|null}
 */
function TextFieldIcon(props) {
    const { className, icon, onClick, style } = props

    if (!icon) {
        return null
    }

    return (
        <div className={cx(className, 't3sel-textfield-right-icon')} {...{ onClick, style }}>
            {icon}
        </div>
    )
}

TextFieldIcon.propTypes = propTypes

export default TextFieldIcon
